import { Injectable } from '@angular/core';
import { Observable } from "rxjs/Observable";
import { Response, Headers } from '@angular/http';
import { Config } from './config';
import { RestClientService } from './restclient.service';
import { Contrato } from '../modelo/contrato';
import { Parcela } from '../modelo/parcela';
import { Boleto, BoletoHibrido } from '../modelo/boleto';
import { SessaoService } from './sessao.service';
import { Cliente } from '../modelo/cliente';
import { SegundaViaRequest } from '../modelo/segundaViaContrato';

@Injectable()
export class SegundaViaService {

    constructor(
        private restClient: RestClientService,
        private sessaoService: SessaoService
    ) {

    }

    listarContrato = (): Observable<Cliente> => {
        let resourcePath = Config.SEGUNDAVIACARNE_PATH + "/listarContrato";
        resourcePath += "/nuCTRL/" + this.sessaoService.sessao.autenticado.nuCTRL;
        return this.restClient.getResource(resourcePath).map(response => response.json());
    };

    recuperarContrato = (contrato: Contrato): Observable<Contrato> => {
        let resourcePath = Config.SEGUNDAVIACARNE_PATH + "/recuperarContrato";
        resourcePath += "/nuCTRL/" + this.sessaoService.sessao.autenticado.nuCTRL;
        resourcePath += "/nuContrato/" + contrato.nuContratoFormatado;
        resourcePath += "/nuCarteira/" + contrato.nuCarteira;
        return this.restClient.getResource(resourcePath).map(response => response.json());
    };

    recuperarEndereco = (nuContrato: number, nuCarteira: number): Observable<Cliente> => {
        let resourcePath = Config.SEGUNDAVIACARNE_PATH + "/recuperarEndereco";
        resourcePath += "/nuCTRL/" + this.sessaoService.sessao.autenticado.nuCTRL;
        resourcePath += "/nuContrato/" + nuContrato;
        resourcePath += "/nuCarteira/" + nuCarteira;
        return this.restClient.getResource(resourcePath).map(response => response.json());
    };

    solicitarSegundaViaCarne = (contrato: Contrato): Observable<Cliente> => {
        let resourcePath = Config.SEGUNDAVIACARNE_PATH + "/solicitarSegundaViaCarnePost";
        const request : SegundaViaRequest = {
          nuCTRL: this.sessaoService.sessao.autenticado.nuCTRL,
          nuContrato: contrato.nuContrato.toString(),
          nuCarteira: contrato.nuCarteira.toString()
        };
      return this.restClient.postResource(resourcePath, request);
    };

    recuperarDadosBolepix = (contrato: Contrato, parcela: Parcela): Observable<BoletoHibrido> => {
        let resourcePath = Config.SEGUNDAVIACARNE_PATH + "/recuperarDadosBolepix";
        resourcePath +=  "/id/" + contrato.nuContrato + this.sessaoService.sessao.autenticado.nuCpfCnpjText;

        resourcePath +=  "/nuParcela/" + parcela.nuParcela.toString();
        resourcePath += "/nuCTRL/" + this.sessaoService.sessao.autenticado.nuCTRL;
        resourcePath += "/nuContrato/" + contrato.nuContrato;
        resourcePath += "/nuCarteira/" + contrato.nuCarteira;

        return this.restClient.getResource(resourcePath).map(response => response.json());
    };

    recuperarDadosBoletoRegistrado = (contrato: Contrato, parcela: Parcela): Observable<Boleto> => {
        let resourcePath = Config.SEGUNDAVIACARNE_PATH + "/recuperarDadosBoletoRegistrado";
        resourcePath += "/nuCTRL/" + this.sessaoService.sessao.autenticado.nuCTRL;
        resourcePath += "/nuContrato/" + contrato.nuContrato;
        resourcePath += "/nuCarteira/" + contrato.nuCarteira;
        resourcePath += "/nuParcela/" + parcela.nuParcela;
        return this.restClient.getResource(resourcePath).map(response => response.json());
    };

    recuperarDadosBoletoNaoRegistrado = (contrato: Contrato, parcela: Parcela): Observable<Boleto> => {
        let resourcePath = Config.SEGUNDAVIACARNE_PATH + "/recuperarDadosBoletoNaoRegistrado";
        resourcePath += "/nuCTRL/" + this.sessaoService.sessao.autenticado.nuCTRL;
        resourcePath += "/nuContrato/" + contrato.nuContrato;
        resourcePath += "/nuCarteira/" + contrato.nuCarteira;
        resourcePath += "/nuParcela/" + parcela.nuParcela;
        return this.restClient.getResource(resourcePath).map(response => response.json());
    };
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/services/segundavia.service.ts